/**
 * S7.6-A — DeviceInventoryCard
 *
 * Card no topo do DeviceDetail (acima das abas) com os 6 campos de
 * identidade do equipamento:
 *
 *   Serial / QR    — inventory.qr_serial || binding.qr_serial
 *   MAC            — inventory.mac (firmware não envia no hb;
 *                    fallback "—" quando não há inventory item)
 *   Cliente        — device.customer_code (nome não disponível no
 *                    /center atual; só código)
 *   Instalado em   — inventory.created_at || binding.created_at ||
 *                    device.created_at
 *   Último HB      — device.last_seen via <OfflineAgingBadge />
 *   Firmware       — device.fw_version || heartbeat.fw
 *
 * Status removido (redundância com Último HB já com aging).
 *
 * Layout: grid 2 colunas no desktop (md:grid-cols-2), 1 no mobile.
 * Mantém glass-card-pad para combinar com cards das abas.
 */
import OfflineAgingBadge from "./OfflineAgingBadge.jsx";
import { t } from "../i18n/index.js";

function fmtDate(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("pt-BR", {
    day: "2-digit", month: "2-digit", year: "numeric",
  });
}

function Row({ label, value, mono }) {
  return (
    <div className="flex items-center justify-between gap-3 py-1
                    border-b border-noc-border/30 last:border-0">
      <span className="text-xs uppercase tracking-wider
                       text-noc-muted">
        {label}
      </span>
      <span className={"text-sm " + (mono ? "font-mono" : "")}>
        {value}
      </span>
    </div>
  );
}

export default function DeviceInventoryCard({ data }) {
  const d  = data?.device || {};
  const hb = data?.heartbeat || {};
  const inv = data?.inventory || {};
  const b  = data?.binding || {};

  const serial = inv.qr_serial || b.qr_serial || "—";
  const mac    = inv.mac || "—";
  const customer = d.customer_code || "—";
  const installedAt = fmtDate(inv.created_at || b.created_at || d.created_at);
  const firmware = d.fw_version || hb.fw || "—";

  const tI = (k) => t("deviceDetail.inventory." + k);

  return (
    <div className="glass-card-pad">
      <div className="font-mono text-[10.5px] font-semibold uppercase tracking-[0.18em]
                      text-noc-muted mb-2">
        {tI("title")}
      </div>
      <div className="grid md:grid-cols-2 gap-x-6">
        <Row label={tI("serial")}      value={serial}   mono />
        <Row label={tI("mac")}         value={mac}      mono />
        <Row label={tI("customer")}    value={customer} />
        <Row label={tI("installedAt")} value={installedAt} />
        <Row label={tI("lastHb")}
             value={<OfflineAgingBadge lastSeen={d.last_seen} />} />
        <Row label={tI("firmware")}    value={firmware} mono />
      </div>
    </div>
  );
}
